import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-pop-up-modal-custom',
    templateUrl: './pop-up-modal-custom.component.html',
    styleUrls: ['./pop-up-modal-custom.component.scss'],
})
export class PopUpModalCustomComponent implements OnChanges, OnDestroy {

    @Input() show = false;
    @Input() titulo = '';
    @Input() mensaje = '';
    @Input() tipo: 'info' | 'success' | 'warning' | 'error' = 'warning';
    @Input() textoBoton = 'Aceptar';
    @Input() textoBotonCancelar = '';
    @Input() mostrarBoton = true;
    @Input() ancho = '';
    @Input() variante: 'solicitud' | undefined = undefined;

    /** Milisegundos para cerrarse solo. 0 = sin autocierre. */
    @Input() tiempoAutoCierre = 0;

    @Output() cerrado = new EventEmitter<void>();
    @Output() confirmado = new EventEmitter<void>();

    private autoCierreTimer?: ReturnType<typeof setTimeout>;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.show || changes.tiempoAutoCierre || changes.mostrarBoton) {
            if (this.show) {
                this.programarAutoCierre();
            } else {
                this.limpiarAutoCierre();
            }
        }
    }

    ngOnDestroy(): void {
        this.limpiarAutoCierre();
    }

    private programarAutoCierre(): void {
        this.limpiarAutoCierre();
        if (this.tiempoAutoCierre > 0) {
            this.autoCierreTimer = setTimeout(() => this.cerrar(), this.tiempoAutoCierre);
        }
    }

    private limpiarAutoCierre(): void {
        if (this.autoCierreTimer) {
            clearTimeout(this.autoCierreTimer);
            this.autoCierreTimer = undefined;
        }
    }

    iconoPorTipo(tipo: string): string {
        switch (tipo) {
            case 'info':
                return 'fas fa-info-circle';
            case 'success':
                return 'fas fa-check-circle';
            case 'error':
                return 'fas fa-times-circle';
            case 'warning':
            default:
                return 'fas fa-exclamation-triangle';
        }
    }

    cerrar(): void {
        this.limpiarAutoCierre();
        this.show = false;
        this.cerrado.emit();
    }

    confirmar(): void {
        this.limpiarAutoCierre();
        this.show = false;
        this.confirmado.emit();
    }
}
